import React, { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { Link } from "react-router-dom";
import CalendarioTabela from "./CalendarioTabela";
import CalendarioService from "../../services/CalendarioService.";
import Swal from 'sweetalert2';
import ICalendario from "../../interfaces/ICalendario";
import CalendarioModal from "./CalendarioModal";
import { useHistory } from "react-router-dom";

const Calendario = () => {
    const { classes } = useLayout();
    const intl = useIntl();
    const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
    const [calendarios, setCalendarios] = useState<ICalendario[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const history = useHistory();


    const AcoesCalendarios = ({ item, excluirCalendario, editarCalendario }: { item: ICalendario, excluirCalendario: (calendario: ICalendario) => void, editarCalendario: (calendario: ICalendario) => void }) => {
        return <div data-tag="allowRowEvents">
            <i onClick={() => { editarCalendario(item) }} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}></i>
            <i onClick={() => { excluirCalendario(item) }} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}></i>
        </div>
    }

    useEffect(() => {
        async function obterTodosCalendariosIniciais() {
            try {
                const todosCalendarios = await CalendarioService.obterTodos();
                setCalendarios(todosCalendarios);
            } catch (error) {
                console.log('Não foi possivel carregar os calendarios iniciais')
            }

            setPaginaCarregada(true);
        }

        obterTodosCalendariosIniciais();
    }, []);

    function toggleModal(): void {
        let show = !showModal;

        setShowModal(show);
    }

    async function excluirCalendario(calendario: ICalendario) {
        try {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-modal-excluir ms-5',
                    cancelButton: 'btn btn-modal-cancelar'
                },
                buttonsStyling: false
            });

            let result = await swalWithBootstrapButtons.fire({
                title: 'Excluir Calendário',
                text: `Você realmente deseja excluir esse calendário?`,
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: `Excluir`,
                reverseButtons: true
            });

            if (result.isConfirmed && calendario.id) {
                await CalendarioService.excluir(calendario.id);

                setCalendarios(calendarios.filter(e => e.id !== calendario.id));

                await Swal.fire({
                    title: '',
                    text: 'Excluido',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000,
                })
            }
        } catch (error) {
            Swal.fire({
                text: 'Não foi possivel excluir o calendário', //TODO: Tratar mensagem de erro
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    async function importar(calendario: ICalendario) {
        try {
            const result = await CalendarioService.importarCalendario(calendario);

            await setCalendarios(old => [...old, result]);

            toggleModal();

            await Swal.fire({
                text: 'Calendário importado com sucesso',
                timer: 4000,
                icon: 'success',
                showConfirmButton: false
            });
        } catch (error) {
            Swal.fire({
                text: 'Não foi possivel importar o calendário', //TODO: Tratar mensagem de erro
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });
        }
    }

    const columns = [
        {
            name: 'Nome do Calendário',
            selector: (row: ICalendario) => row['nomeCalendario'],
            sortable: true,
        },
        {
            name: 'Tipo',
            selector: (row: ICalendario) => row['tipo'],
            sortable: true,
        },
        {
            name: 'Ações',
            cell: (row: ICalendario) => <AcoesCalendarios excluirCalendario={excluirCalendario} editarCalendario={(calendario: ICalendario) => {
                history.push("/calendario/editar/" + calendario.id);
            }} item={row} />,
        }
    ];

    return <>
        <PageTitle>{intl.formatMessage({ id: 'MENU.CALENDAR' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
                <CalendarioModal importar={importar} show={showModal} toggleModal={toggleModal} />
                <div className='d-flex align-items-center py-1'>
                    <button onClick={() => {
                        setShowModal(true);
                    }} className='btn btn-sm btn-primario'>
                        <i className="text-white fas fa-upload"></i>
                        <span style={{ verticalAlign: 'middle' }}> IMPORTAR </span>
                    </button>
                    <Link to="/calendario/novo">
                        <button className='btn btn-sm btn-primario ms-5'>
                            <i className="text-white fas fa-plus"></i>
                            <span style={{ verticalAlign: 'middle' }}> CALENDÁRIO </span>
                        </button>
                    </Link>
                </div>
            </div>
        </div>

        {
            paginaCarregada ?
                <CalendarioTabela colunas={columns} itens={calendarios} />
            :
                <p>Carregando...</p>
        }
    </>
}

export default Calendario;